export const agencies = new Map()
  .set("8000020130001", {
    agency_id: "8000020130001",
    agency_name: "都営バス",
    agency_url: "https://www.kotsu.metro.tokyo.jp/bus/",
    agency_color: "#227324",
  })
  .set("7000020141305", {
    agency_id: "7000020141305",
    agency_name: "川崎市バス",
    agency_url: "https://www.city.kawasaki.jp/820/",
    agency_color: "#00789F",
  })
  .set("4040001028454", {
    agency_id: "4040001028454",
    agency_name: "京成バス千葉ウエスト株式会社 塩浜営業所",
    agency_url: "https://www.transitbus.co.jp/web/",
    agency_color: "#E21413",
  });

// .set("3000020141003", {
//   agency_id: "3000020141003",
//   agency_name: "横浜市交通局",
//   agency_url: "https://www.city.yokohama.lg.jp/kotsu/",
//   agency_color: "#1B1464",
// });
// .set("9013401002381", {
//   agency_id: "9013401002381",
//   agency_name: "京王電鉄バス株式会社",
//   agency_url: "https://www.keio-bus.com/",
//   agency_color: "#0B3774",
// });
